module.exports = __webpack_public_path__ + "static/media/header-mobile.4fb29836.jpg";